import { datadogRum } from '@datadog/browser-rum';
import { update } from '@intercom/messenger-js-sdk';

export const getSessionReplayAttrs = () => {
  try {
    const link = datadogRum.getSessionReplayLink();
    return link ? { session_replay_link: link } : null;
  } catch {
    return null;
  }
};

export const pushSessionReplayLinkToIntercom = () => {
  const attrs = getSessionReplayAttrs();
  if (attrs) update(attrs);
};
